import type { OpsApi } from "../useOps";
import { SEVERITY_COLOR } from "@/types/api";

/** Toast stack at the top of the map — one per new/escalated signal. */
export function Toasts({ ops }: { ops: OpsApi }) {
  return (
    <div className="toasts">
      {ops.toasts.map((t) => (
        <div
          key={t.id}
          className="toast"
          style={{ ["--sev" as string]: SEVERITY_COLOR[t.severity], cursor: "pointer" }}
          onClick={() => ops.selectSignal(t.signalId)}
        >
          <span className="tg">
            {t.revised ? "↑ " : ""}
            {t.severity}
            {t.revised ? " · revised" : ""}
          </span>
          <span className="bar" />
          <span className="tt">{t.title}</span>
        </div>
      ))}
    </div>
  );
}
